module.exports = __webpack_public_path__ + "media/standardized_tests/sticky_01-eb629fd5.jpg";